<template>
        <md-card v-if="report">
            <md-card-header class="md-card-header-icon md-card-header-blue">
                <div class="card-icon">
                    <font-awesome-icon class="md-icon" :icon="['fa', 'file']"/>
                </div>
                <h4 class="title">Rapport d'intervention</h4>
            </md-card-header>
            <md-card-content>
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-100">
                        <h6 class="my-3">Situation</h6>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-100">
                                <div class="md-input-radio">
                                    <label>Présence de nuisibles *</label>
                                    <div>
                                        <md-radio v-model="report.isInsects" class="my-2" :value="'1'">Oui</md-radio>
                                        <md-radio v-model="report.isInsects" class="my-2" :value="'0'">Non</md-radio>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template v-if="report.isInsects === '1'">
                            <div class="md-layout">
                                <div class="md-layout-item md-size-100">
                                    <div class="md-multiselect">
                                        <label>Insecte *</label>
                                        <multiselect v-model="selectedInsect"
                                                     :options="config.insects"
                                                     :show-labels="false"
                                                     placeholder="Insecte"
                                                     label="name"
                                                     track-by="id">
                                            <template slot="noOptions">La liste est vide</template>
                                            <template slot="noResult">Aucun élement correspondant</template>
                                        </multiselect>
                                        <validation-error :errors="apiValidationErrors.insect" />
                                    </div>
                                </div>
                            </div>
                            <div class="md-layout mt-1">
                                <div class="md-layout-item md-size-100">
                                    <md-field class="md-invalid">
                                        <label>Autre insecte {{ report.insectId && report.insectId === '0' ? '*' : '' }}</label>
                                        <md-input v-model="report.insectOther" type="text" name="insect-other"
                                                  :disabled="report.insectId === 'null' || report.insectId !== '0'" />
                                        <validation-error :errors="apiValidationErrors.insectOther" />
                                    </md-field>
                                </div>
                            </div>
                            <div class="md-layout mt-3">
                                <div class="md-layout-item md-size-100">
                                    <div class="md-multiselect">
                                        <label>Degré d'infestation *</label>
                                        <multiselect v-model="report.insectQuantity"
                                                     :options="config.insectsQuantity"
                                                     :show-labels="false"
                                                     :allow-empty="false">
                                            <template slot="noOptions">La liste est vide</template>
                                            <template slot="noResult">Aucun élement correspondant</template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="md-layout mt-1">
                                <div class="md-layout-item md-size-100">
                                    <md-field class="md-invalid">
                                        <label>Localisation *</label>
                                        <md-input v-model="report.insectLocation" type="text" name="insect-location" />
                                        <validation-error :errors="apiValidationErrors.location" />
                                    </md-field>
                                </div>
                            </div>
                        </template>
                        <h6 class="my-3">Commentaires / Actions</h6>

                        <div class="md-layout">
                            <div class="md-layout-item md-size-100">
                                <div class="md-input-radio">
                                    <label>Autres produits *</label>
                                    <div>
                                        <md-radio v-model="report.otherProducts" class="my-2" :value="'1'">Oui</md-radio>
                                        <md-radio v-model="report.otherProducts" class="my-2" :value="'0'">Non</md-radio>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-100">
                                <div class="md-multiselect md-multiselect-multiple">
                                    <label>Autres produits utilisés</label>
                                    <multiselect v-model="selectedProducts"
                                                 :options="config.products"
                                                 :disabled="disableProductSelection"
                                                 :multiple="true"
                                                 :close-on-select="false"
                                                 :show-labels="false"
                                                 placeholder="Produits"
                                                 label="name"
                                                 track-by="id">
                                        <template slot="noOptions">La liste est vide</template>
                                        <template slot="noResult">Aucun élement correspondant</template>
                                    </multiselect>
                                    <validation-error :errors="apiValidationErrors.products" />
                                </div>
                            </div>
                        </div>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-100">
                                <md-field class="md-invalid">
                                    <label>Commentaire libre</label>
                                    <md-textarea v-model="report.comment" name="comment" md-autogrow />
                                </md-field>
                            </div>
                        </div>
                        <h6 class="my-3">Conseils</h6>
                        <div class="flex items-center justify-start">
                            <div class="md-input-radio md-invalid">
                                <label>Environnement *</label>
                                <div>
                                    <md-radio v-model="report.adviceEnvironment" class="my-2 md-danger" :value="'1'"><span class="text-danger">1</span></md-radio>
                                    <md-radio v-model="report.adviceEnvironment" class="my-2 md-warning" :value="'2'"><span class="text-warning">2</span></md-radio>
                                    <md-radio v-model="report.adviceEnvironment" class="my-2 md-success" :value="'3'"><span class="text-success">3</span></md-radio>
                                </div>
                                <validation-error :errors="apiValidationErrors.adviceEnvironment" />
                            </div>
                            <div class="text-xs font-medium" :class="`text-${selectedAdvice('Environment').color}`">
                                {{ selectedAdvice('Environment').text }}
                            </div>
                        </div>
                        <div class="flex items-center justify-start mt-1">
                            <div class="md-input-radio md-invalid">
                                <label>Déchets *</label>
                                <div>
                                    <md-radio v-model="report.adviceWaste" class="my-2 md-danger" :value="'1'"><span class="text-danger">1</span></md-radio>
                                    <md-radio v-model="report.adviceWaste" class="my-2 md-warning" :value="'2'"><span class="text-warning">2</span></md-radio>
                                    <md-radio v-model="report.adviceWaste" class="my-2 md-success" :value="'3'"><span class="text-success">3</span></md-radio>
                                </div>
                                <validation-error :errors="apiValidationErrors.adviceWaste" />
                            </div>
                            <div class="text-xs font-medium" :class="`text-${selectedAdvice('Waste').color}`">
                                {{ selectedAdvice('Waste').text }}
                            </div>
                        </div>
                        <div class="flex items-center justify-start mt-1">
                            <div class="md-input-radio md-invalid">
                                <label>Végétation *</label>
                                <div>
                                    <md-radio v-model="report.adviceVegetation" class="my-2 md-danger" :value="'1'"><span class="text-danger">1</span></md-radio>
                                    <md-radio v-model="report.adviceVegetation" class="my-2 md-warning" :value="'2'"><span class="text-warning">2</span></md-radio>
                                    <md-radio v-model="report.adviceVegetation" class="my-2 md-success" :value="'3'"><span class="text-success">3</span></md-radio>
                                </div>
                                <validation-error :errors="apiValidationErrors.adviceVegetation" />
                            </div>
                            <div class="text-xs font-medium" :class="`text-${selectedAdvice('Vegetation').color}`">
                                {{ selectedAdvice('Vegetation').text }}
                            </div>
                        </div>
                        <div class="flex items-center justify-start mt-1">
                            <div class="md-input-radio md-invalid">
                                <label>Étanchéité *</label>
                                <div>
                                    <md-radio v-model="report.adviceTightness" class="my-2 md-danger" :value="'1'"><span class="text-danger">1</span></md-radio>
                                    <md-radio v-model="report.adviceTightness" class="my-2 md-warning" :value="'2'"><span class="text-warning">2</span></md-radio>
                                    <md-radio v-model="report.adviceTightness" class="my-2 md-success" :value="'3'"><span class="text-success">3</span></md-radio>
                                </div>
                                <validation-error :errors="apiValidationErrors.adviceTightness" />
                            </div>
                            <div class="text-xs font-medium" :class="`text-${selectedAdvice('Tightness').color}`">
                                {{ selectedAdvice('Tightness').text }}
                            </div>
                        </div>
                        <div class="flex items-center justify-start mt-1">
                            <div class="md-input-radio md-invalid">
                                <label>Sources d'attraction *</label>
                                <div>
                                    <md-radio v-model="report.adviceAttractionSource" class="my-2 md-danger" :value="'1'"><span class="text-danger">1</span></md-radio>
                                    <md-radio v-model="report.adviceAttractionSource" class="my-2 md-warning" :value="'2'"><span class="text-warning">2</span></md-radio>
                                    <md-radio v-model="report.adviceAttractionSource" class="my-2 md-success" :value="'3'"><span class="text-success">3</span></md-radio>
                                </div>
                                <validation-error :errors="apiValidationErrors.adviceAttractionSource" />
                            </div>
                            <div class="text-xs font-medium" :class="`text-${selectedAdvice('AttractionSource').color}`">
                                {{ selectedAdvice('AttractionSource').text }}
                            </div>
                        </div>
                        <div class="flex items-center justify-start mt-1">
                            <div class="md-input-radio md-invalid">
                                <label>Accès aux dispositifs *</label>
                                <div>
                                    <md-radio v-model="report.adviceDevicesAccess" class="my-2 md-danger" :value="'1'"><span class="text-danger">1</span></md-radio>
                                    <md-radio v-model="report.adviceDevicesAccess" class="my-2 md-warning" :value="'2'"><span class="text-warning">2</span></md-radio>
                                    <md-radio v-model="report.adviceDevicesAccess" class="my-2 md-success" :value="'3'"><span class="text-success">3</span></md-radio>
                                </div>
                                <validation-error :errors="apiValidationErrors.adviceDevicesAccess" />
                            </div>
                            <div class="text-xs font-medium" :class="`text-${selectedAdvice('DevicesAccess').color}`">
                                {{ selectedAdvice('DevicesAccess').text }}
                            </div>
                        </div>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-100">
                                <md-field class="md-invalid">
                                    <label>Temps de travail *</label>
                                    <md-input type="time" v-model="report.duration" />
                                    <validation-error :errors="apiValidationErrors.duration" />
                                </md-field>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="md-layout md-gutter mt-2">
                    <div class="md-layout-item md-size-100">
                        <md-button class="md-success md-icon-button md-raised my-0"
                                   @click="updateReport">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'check-circle']" />
                            <span class="leading-none font-medium ml-2">Modifier le rapport</span>
                        </md-button>
                    </div>
                </div>
            </md-card-content>
        </md-card>

</template>

<script>

import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "Report",
    components: { ValidationError },
    mixins: [formMixin],
    props: {
        intervention: {
            type: Object,
            required: true
        }
    },
    data(){
        return {
            config: {
                insects: [],
                insectsQuantity: ['Faible', 'Modéré', 'Élevé'],
                products: [],
            },
            reportStructure: {
                isInsects: '0',
                insectId: 'null',
                insectOther: '',
                insectQuantity: 'Faible',
                insectLocation: '',
                otherProducts: '0',
                products: 'null',
                comment: '',
                adviceEnvironment: '3',
                adviceWaste: '3',
                adviceVegetation: '3',
                adviceTightness: '3',
                adviceAttractionSource: '3',
                adviceDevicesAccess: '3',
                duration: '00:00'
            },
            report: null,
            awaitingRequest: false,
        }
    },
    methods: {
        async getInsects() {
            const { data } = await this.$store.dispatch('insects/getAllInsects')
            this.config.insects.push(...data, { id: 0, name: 'Autre (à saisir)' })
        },
        async getProducts() {
            const { data } = await this.$store.dispatch('products/getAllProducts')
            this.config.products = data
        },
        getDuration() {
            let duration = this.$moment.duration(this.report.duration, 'minutes')
            return this.$moment.utc(duration.as('milliseconds')).format('HH:mm')
        },

        selectedAdvice(advice) {
            const reportAdvice = this.report['advice'+advice]
            if(reportAdvice) {
                return reportAdvice === '1' ? { text: 'Problématique', color: 'danger' } :
                    (reportAdvice === '2' ? { text: 'À améliorer', color: 'warning' } :
                        (reportAdvice === '3' ? { text: 'Satisfaisant', color: 'success' } : ''))

            } else {
                return { text: '', color: 'default' }
            }
        },
        validateReport() {
            let errors = []
            this.resetApiValidation()
            if(this.report.isInsects === "1") {
                if(this.report.insectId === 'null') {
                    errors.push({
                        source: { pointer: '/data/attributes/insect' },
                        detail: 'Le type de nuisible est obligatoire'
                    })
                } else if(this.report.insectId === '0' && !this.report.insectOther) {
                    errors.push({
                        source: { pointer: '/data/attributes/insectOther' },
                        detail: 'Le type de nuisible est obligatoire'
                    })
                }
                if(!this.report.insectLocation) {
                    errors.push({
                        source: { pointer: '/data/attributes/location' },
                        detail: 'La localisation est obligatoire'
                    })
                }
            }
            if(this.report.otherProducts === '1' && (this.report.products.length === 0 || this.report.products === 'null')) {
                errors.push({
                    source: { pointer: '/data/attributes/products' },
                    detail: 'Au moins un produit doit être sélectionné'
                })
            }
            if(this.report.adviceEnvironment === null) {
                errors.push({
                    source: { pointer: '/data/attributes/adviceEnvironment' },
                    detail: 'Le poids est obligatoire'
                })
            }
            if(this.report.adviceWaste === null) {
                errors.push({
                    source: { pointer: '/data/attributes/adviceWaste' },
                    detail: 'Le poids est obligatoire'
                })
            }
            if(this.report.adviceVegetation === null) {
                errors.push({
                    source: { pointer: '/data/attributes/adviceVegetation' },
                    detail: 'Le poids est obligatoire'
                })
            }
            if(this.report.adviceTightness === null) {
                errors.push({
                    source: { pointer: '/data/attributes/adviceTightness' },
                    detail: 'Le poids est obligatoire'
                })
            }
            if(this.report.adviceAttractionSource === null) {
                errors.push({
                    source: { pointer: '/data/attributes/adviceAttractionSource' },
                    detail: 'Le poids est obligatoire'
                })
            }
            if(this.report.adviceDevicesAccess === null) {
                errors.push({
                    source: { pointer: '/data/attributes/adviceDevicesAccess' },
                    detail: 'Le poids est obligatoire'
                })
            }
            if(!this.report.duration) {
                errors.push({
                    source: { pointer: '/data/attributes/duration' },
                    detail: 'Le temps de travail est obligatoire'
                })
            }
            if(errors.length > 0) {
                this.setApiValidation(errors)
            }
        },
        async updateReport () {
            this.validateReport()
            if (_.isEmpty(this.apiValidationErrors)) {
                const timeParts = this.report.duration.split(':')
                const duration = (parseInt(timeParts[0]) * 60) + parseInt(timeParts[1])
                const report = JSON.stringify({
                    isInsects: this.report.isInsects,
                    insectId: this.report.isInsects ? this.report.insectId : 'null',
                    insectOther: this.report.isInsects ? this.report.insectOther : 'null',
                    insectQuantity: this.report.isInsects ? this.report.insectQuantity : 'null',
                    insectLocation: this.report.isInsects ? this.report.insectLocation : 'null',
                    otherProducts: this.report.otherProducts,
                    products: this.report.products && this.report.products.length > 0 ? this.report.products : 'null',
                    comment: this.report.comment,
                    adviceEnvironment: this.report.adviceEnvironment.toString(),
                    adviceWaste: this.report.adviceWaste.toString(),
                    adviceVegetation: this.report.adviceVegetation.toString(),
                    adviceTightness: this.report.adviceTightness.toString(),
                    adviceAttractionSource: this.report.adviceAttractionSource.toString(),
                    adviceDevicesAccess: this.report.adviceDevicesAccess.toString(),
                    duration: duration.toString()
                })
                const { data } = await this.$store.dispatch('interventions/updateReportData', {
                    interventionId: this.intervention.id,
                    model_value: report
                })
                this.$emit('update-report', data)
                await this.$store.dispatch('alerts/success', 'Le rapport a bien été modifié')
            } else {
                await this.$store.dispatch('alerts/error', 'Au moins un champ n\'a pas été rempli')
            }
        }
    },
    mounted() {
        this.getInsects()
        this.getProducts()
        // If a report already exists, get the values related
        if (this.intervention.report) {
            this.report = JSON.parse(this.intervention.report.model_value)
        }
        // Also check if report doesn't exist or contains a V1 model value to
        if (!this.report || (this.report && this.report.madate)) {
            this.report = _.cloneDeep(this.reportStructure)
        }
        this.report.duration = this.getDuration()
    },
    computed: {
        selectedInsect: {
            get() {
                //Get available products id(integer) and find the correspondance with used products(string)
                return this.config.insects.find(o => o.id.toString() === this.report.insectId)
            },
            set(val) {
                this.report.insectId = val.id.toString()
            }
        },
        selectedProducts: {
            get() {
                if(this.report.products) {
                    //Get available products id(integer) and find the correspondance with used products(string)
                    return this.config.products.filter(o => this.report.products.includes(o.id.toString()))
                }
                return []
            },
            set(val) {
                this.report.products = val.map(o => o.id.toString())
            }
        },
        disableProductSelection () {
            return this.report.otherProducts === '0'
        },
    },
    watch: {
        'report.otherProducts'() {
            if (this.report.otherProducts === '0') {
                this.report.products = []
            }
        }
    }
}
</script>

<style scoped>

</style>
